"use client";

import { useEffect } from "react";

import { LOCAL_STORAGE_KEYS } from "@/shared/config";
import {
  isNeoFolkThemeId,
  type NeoFolkThemeId,
} from "@/shared/types/neo-folk-theme";

const ATTR = "data-neo-theme";

function applyNeoTheme(id: NeoFolkThemeId | null) {
  const root = document.documentElement;
  if (!id || id === "default") {
    root.removeAttribute(ATTR);
    return;
  }
  root.setAttribute(ATTR, id);
}

export function NeoThemeInit() {
  useEffect(() => {
    const saved = localStorage.getItem(LOCAL_STORAGE_KEYS.ADMIN_NEO_THEME);
    const id = isNeoFolkThemeId(saved) ? saved : null;
    applyNeoTheme(id);
    const handler = (e: Event) => {
      const theme = (e as CustomEvent<{ theme: NeoFolkThemeId | null }>).detail
        ?.theme;
      if (theme !== undefined) applyNeoTheme(theme ?? null);
    };
    window.addEventListener("neo-theme-changed", handler);
    return () => window.removeEventListener("neo-theme-changed", handler);
  }, []);
  return null;
}
